<div class="multi-select-review-dialog">
  <div class="header-container">
    <h2 mat-dialog-title>Review Document</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-divider></mat-divider>
  
  <mat-dialog-content>
    <!-- File Upload Section -->
    <div class="file-upload-section">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Document to Review</mat-label>
        <input matInput [value]="selectedFile?.name || 'No file selected'" readonly>
        <button mat-icon-button matSuffix (click)="fileInput.click()">
          <mat-icon>upload_file</mat-icon>
        </button>
      </mat-form-field>
      <input #fileInput type="file" style="display: none" 
             accept="application/pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document" (change)="onFileSelected($event)">
    </div>

    <!-- Reviewer Selection Section -->
    <div class="reviewer-selection-section">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>Select Reviewers</mat-label>
        <mat-select multiple [(ngModel)]="selectedPersonas" (selectionChange)="onPersonaSelectionChange($event.value)">
          <!-- Select All / Deselect All Toggle -->
          <mat-option class="select-all-option"
                      [value]="'__SELECT_ALL__'"
                      (click)="toggleSelectAll(); $event.stopPropagation()">
            {{ allSelected ? 'Deselect All' : 'Select All' }}
          </mat-option>
          <!-- Individual Persona Options -->
          <mat-option *ngFor="let persona of personas" 
                      [value]="persona"
                      [matTooltip]="persona.summary || ''">
            {{ persona.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Selected Reviewers Display -->
    <div class="selected-reviewers-section" *ngIf="selectedPersonas.length > 0">
      <p class="section-label">Selected Reviewers:</p>
      <mat-chip-listbox>
        <mat-chip *ngFor="let persona of selectedPersonas" 
                  [removable]="true"
                  (removed)="removePersona(persona)">
          {{ persona.name }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-listbox>
    </div>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" 
            [disabled]="isSubmitDisabled"
            (click)="onSubmit()">
      Submit for Review
    </button>
  </mat-dialog-actions>
</div>
